import axios from "axios";
import getCARTOData from "@/store/utils/getCARTOData"
import { toString } from "lodash";

export default class PublicClient {
  constructor(apiURI = "") {
    this.apiURI = apiURI;
  }

  get(...args) {
    return this.request("get", ...args);
  }

  put(...args) {
    return this.request("put", ...args);
  }

  post(...args) {
    return this.request("post", ...args);
  }

  delete(...args) {
    return this.request("delete", ...args);
  }

  addHeaders(obj, additional) {
    return Object.assign({}, obj.headers, additional);
  }

  paramsToURI(params) {
    const DEFAULT_PARAMS = "";

    return this.checkParams(params)
      ? `?${Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join("&")}`
      : DEFAULT_PARAMS;
  }

  checkParams(params) {
    const OBJECT_TYPE = "[object Object]";

    return (
      params &&
      toString(params) === OBJECT_TYPE &&
      Object.keys(params).length
    );
  }

  makeRelativeURI(parts) {
    return `/${parts.join("/")}`;
  }

  makeAbsoluteURI(relativeURI) {
    return `${this.apiURI}${relativeURI}`;
  }

  addApiKey(uri) {
    const { api_key } = getCARTOData().user_data;

    if (api_key) {
      return `${uri}&api_key=${api_key}`;
    } else return uri;
  }

  request(method, uriParts, opts = {}, callback) {
    if (!callback && typeof opts === "function") {
      callback = opts;
      opts = {};
    }

    const contentType = opts.doNoSetDefaultContentType
      ? false
      : "application/json; charset=utf-8";

    Object.assign(opts, {
      contentType: contentType,
      method: method.toUpperCase(),
    });

    this.addHeaders(opts);

    const baseUrl = opts.baseUrl;
    let url =
      uriParts.length !== 0
        ? this.makeAbsoluteURI(this.makeRelativeURI(uriParts))
        : "";

    const requestConfig = {
      url,
      method: opts.method,
      baseURL: baseUrl,
      headers: opts.headers,
      params: {
        timestamp: new Date().getTime()
      },
      withCredentials: true
    };
    const apiKeyExist = url.indexOf("api_key")
    const { api_key } = getCARTOData().user_data;

    if (apiKeyExist < 0 && api_key) {
      requestConfig.params.api_key = api_key;
    }
    const axiosInstance = axios.create();
    if (callback) {
      axiosInstance.interceptors.response.use(
        function (response) {
          const { data } = response;
          return callback(null, response, data);
        },
        function (error) {
          return callback(error, null, null);
        }
      );
    }
    return axiosInstance.request(requestConfig);
  }
}
